import React, { useState } from 'react';
import { Box, Tooltip, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/common/auth/hooks/useAuth';
import { useTheme } from '../../../../../theme';
import { useIsElectron } from '@/context/ElectronContext';
import UserMenu from './UserMenu';
import { client } from '@/apollo';

import ProfileDialog from '../../../userProfile/UserProfilePage';
import InvitationNotifications from '../../../_misc/InvitationNotifications';

const HeaderRight: React.FC = () => {
  const { user, logout } = useAuth();
  const { mode, toggleTheme } = useTheme();
  const isElectron = useIsElectron();
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Clear Apollo Client cache to prevent stale data
    client.clearStore();
    logout();
  };

  const handleDownloadClick = () => {
    navigate('/download');
  };

  // Convert user to UserType format for UserMenu
  const userForMenu = user
    ? {
        email: user.email || null,
        name:
          user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : user.firstName || null,
        image: user.image || null,
      }
    : null;

  if (!userForMenu) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          right: { xs: 0, sm: 15 },
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.25, sm: 1 },
          '& .MuiIconButton-root': {
            p: { xs: 0.5, sm: 1 },
          },
          '& .MuiSvgIcon-root': {
            fontSize: { xs: 20, sm: 24 },
          },
        }}
      >
        <>
          {!isElectron && (
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Tooltip title="Download Desktop App">
                <IconButton
                  onClick={handleDownloadClick}
                  aria-label="Download Desktop App"
                  size="medium"
                  sx={{
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'studio.borders.control',
                    bgcolor: 'studio.surfaces.fillWeak',
                    color: 'primary.main',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: (theme) =>
                        alpha(theme.palette.primary.main, 0.45),
                      bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, 0.09),
                      transform: 'translateY(-1px)',
                    },
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          <InvitationNotifications />
          <UserMenu
            user={userForMenu}
            mode={mode}
            logout={handleLogout}
            toggleTheme={toggleTheme}
          />
        </>
      </Box>

      {profileDialogOpen && (
        <ProfileDialog
          open={profileDialogOpen}
          onClose={() => setProfileDialogOpen(false)}
        />
      )}
    </>
  );
};

export default HeaderRight;
